/** `c_fFrameTime`, one frame of the motion event clock: one over
 *  `g_fGameFPS` (`RaceMotionData.cpp:311`, `GameType.cpp:5`). */
export const MOTION_EVENT_FRAME_S = 1 / 60; // RaceMotionData.cpp:311, GameType.cpp:5

/** The hide and show starting times a clip row carries, in seconds. */
export interface CharacterEvents {
  readonly hideS?: readonly number[];
  readonly showS?: readonly number[];
}

/** Whether a body is hidden `localS` into a clip with these events: an event
 *  fires on the frame its `StartingTime` truncates to (`RaceMotionData.cpp:450`,
 *  `ActorInstanceMotionEvent.cpp:39`), a hide takes the body's alpha to 0 and a
 *  show back to 1 (`ActorInstanceMotionEvent.cpp:84-96`), and the latest to
 *  have fired decides. */
export function hiddenAt(events: CharacterEvents, localS: number): boolean {
  const frame = Math.floor(localS / MOTION_EVENT_FRAME_S);
  let decidedAt = -1;
  let hidden = false;
  for (const t of events.hideS ?? []) {
    const at = Math.floor(t / MOTION_EVENT_FRAME_S);
    if (at <= frame && at > decidedAt) {
      decidedAt = at;
      hidden = true;
    }
  }
  for (const t of events.showS ?? []) {
    const at = Math.floor(t / MOTION_EVENT_FRAME_S);
    if (at <= frame && at >= decidedAt) {
      decidedAt = at;
      hidden = false;
    }
  }
  return hidden;
}
